export enum InventoryStatus {
  DAMAGED = 'DAMAGED',
  GOOD = 'GOOD',
  INUSE = 'INUSE',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
}
